import React from 'react'
import ArrowLeftSvg from 'images/modules/Shared/i-arrow-left-agent.svg?raw'

export { default as ArrowLeftAgentUrl } from 'images/modules/Shared/i-arrow-left-agent.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: ArrowLeftSvg}} />
)
